// Thin wrapper around `react-datepicker` that turns on the library's
// built-in "Today" button by default. Centralising this here means every
// date field in the app (task due dates, logbook entries, etc.) gets the
// shortcut without each caller having to remember the prop.
//
// Callers can override the label by passing a custom `todayButton`, or
// disable the footer entirely with `todayButton={null}`.
//
// Refs forward to the underlying `DatePicker` instance so callers can call
// `.setFocus()` on it (used by ModalEditForm's mobile-keyboard handoff for
// forms whose first field is a date, e.g. logbook entries).

import { forwardRef } from 'react';
import DatePicker from 'react-datepicker';

const TaskPogoDatePicker = forwardRef(function TaskPogoDatePicker(
  { todayButton = 'Today', ...props },
  ref
) {
  return <DatePicker ref={ref} todayButton={todayButton} {...props} />;
});

export default TaskPogoDatePicker;
